"use strict";

exports.__esModule = true;
exports.AdvancedMetricChartWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _widgetGroups = require("../widgetGroups");
var _AdvancedMetricChartThumbnail = require("./AdvancedMetricChartThumbnail");
var _AdvancedMetricChartFields = require("./AdvancedMetricChartFields");
var _AdvancedMetricChartElement = require("./AdvancedMetricChartElement");
var _ChartCard = require("../common/ChartCard");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AdvancedMetricChartWidget = exports.AdvancedMetricChartWidget = {
  name: "AdvancedMetricChartWidget",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "AdvancedMetricChartWidget.label",
    defaultMessage: "Advanced Metric Chart (Beta)"
  }),
  icon: "timeline-area-chart",
  group: _widgetGroups.METRIC_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "AdvancedMetricChartWidget",
      props: Object.assign({
        width: 256,
        height: 256,
        chartItems: {
          props: []
        }
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["title", "toolbox", "statistics", "visualMap", "chartItems", "controls"],
  requiresProps: ["x", "y", "width", "height", "selectedMetrics"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 256,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: (0, _ChartCard.withChartCard)(_AdvancedMetricChartElement.AdvancedMetricChartElement, function (props) {
      var _props$title, _props$title2;
      return {
        title: ((_props$title = props.title) == null ? void 0 : _props$title.mainText) || /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "AdvancedMetricChartWidget.card.title",
          defaultMessage: "Metrics"
        }),
        subtitle: (_props$title2 = props.title) == null ? void 0 : _props$title2.subText,
        elementProps: {
          title: Object.assign({}, props.title, {
            show: false
          })
        }
      };
    }),
    Fields: _AdvancedMetricChartFields.AdvancedMetricChartFields,
    Thumbnail: _AdvancedMetricChartThumbnail.AdvancedMetricChartThumbnail
  }
};